import React from "react";
import ReactDOM from "react-dom/client";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { App } from "./components/App";
import { UserProvider } from "./context/UserContext";
import reportWebVitals from "./reportWebVitals";
import { getPostHogInitOptions, getPostHogPublicToken } from "./analytics/posthogConfig";
import { PostHogSessionRecordingGate } from "./analytics/PostHogSessionRecordingGate";
import { APP_NAME } from "./config/branding";

const posthogToken = getPostHogPublicToken();
const posthogOptions = getPostHogInitOptions();

document.title = APP_NAME;

if (process.env.NODE_ENV === "production" && !posthogToken) {
  // CRA bakes REACT_APP_* at `npm run build` — `.env` is ignored for prod builds; use `.env.production` or deploy `source`.
  console.info(
    "[addata] PostHog is disabled: REACT_APP_PUBLIC_POSTHOG_TOKEN was empty at build time. " +
      "Set it in addata-client-react/.env.production before `npm run build` / deploy."
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const appTree = (
  <UserProvider>
    <App />
  </UserProvider>
);

const withGoogle = appTree;

function PosthogErrorFallback(): React.ReactElement {
  return (
    <div
      style={{
        padding: 24,
        fontFamily: "system-ui, sans-serif",
        maxWidth: 480,
        margin: "10vh auto",
      }}
    >
      <p style={{ marginBottom: 12 }}>Something went wrong.</p>
      <button type="button" onClick={() => window.location.reload()}>
        Reload page
      </button>
    </div>
  );
}

root.render(
  posthogToken ? (
    <PostHogProvider apiKey={posthogToken} options={posthogOptions}>
      <PostHogErrorBoundary fallback={<PosthogErrorFallback />}>
        <PostHogSessionRecordingGate />
        {withGoogle}
      </PostHogErrorBoundary>
    </PostHogProvider>
  ) : (
    withGoogle
  )
);

reportWebVitals((metric) => {
  if (!posthogToken) return;
  if (!posthog.__loaded) return;
  posthog.capture("$web_vitals", {
    name: metric.name,
    value: metric.value,
    id: metric.id,
    delta: metric.delta,
  });
});
